import { useAssociatedTokensStore } from "stores/associatedTokens";
import { $api } from ".";

class AssociatedTokensService {
  async fetchTokens() {
    const {
      page,
      pageSize,
      searchQuery,
      isHidden,
      setTokens,
      setTotal,
      setIsLoading,
    } = useAssociatedTokensStore.getState();

    try {
      setIsLoading(true);
      const response = await $api.get("/api/extension/associated-tokens-list", {
        params: {
          page,
          pageSize,
          searchQuery,
          isHidden: isHidden.toString(),
        },
      });

      setTokens(response.data.tokens);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Error fetching tokens:", error);
    } finally {
      setIsLoading(false);
    }
  }

  async toggleHideStatus(tokenId: string, isHidden: boolean) {
    const { setIsLoading } = useAssociatedTokensStore.getState();
    setIsLoading(true);
    try {
      await $api.post("/api/extension/hide-token", { tokenId, isHidden });
    } catch (error) {
      console.error("Error toggling hide status:", error);
    }
  }
}

export const associatedTokensService = new AssociatedTokensService();
